import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, EventEmitter, Input, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RootStoreState, vaultStoreActions } from '@app/root-store';
import { VaultStoreService } from '@app/root-store/vault-store/vault-store.service';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DiscoveryService } from '@app/shared/services/discovery/discovery.service';
import { ShareService } from '@app/shared/services/vault/share.service';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { CommonService } from '@app/shared/services/common/common.service';
import { ToastrService } from 'ngx-toastr';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import * as relationshipSelectors from '../../../root-store/relationship-store/relationship.selector';
import { ConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/enum';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { ItemToResolveService } from '@app/modules/home-page/item-to-resolve-module/item-to-resolve.service';
import { RefreshReportService } from '@app/shared/component/my-report-container/refresh-report.service';
import { HomeSubjectService } from '@app/modules/home-page/container/home-subject.service';
import { DataExtractionToggle } from '@app/shared/services';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipDirective } from '@app/shared/directives/tooltip.directive';
import { DiscoveryConfigurationStatusComponent } from './discovery-configuration-status/discovery-configuration-status.component';
import { AddInstitutionComponent } from '@app/modules/vault/mx-component/dialog/add-institution/add-institution.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DiscoveryTemplateTableFormComponent } from './discovery-template-table-form/discovery-template-table-form.component';
@AutoUnsubscribe()
@Component({
    selector: 'discovery-configuration',
    templateUrl: './discovery-configuration.component.html',
    styleUrl: './discovery-configuration.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      MatExpansionModule,
      MatInputModule,
      FormsModule,
      MatIconModule,
      MatFormFieldModule,
      MatTooltipModule,
      TooltipDirective,
      LottieComponent,
      AddInstitutionComponent,
      DiscoveryConfigurationStatusComponent,
      DiscoveryTemplateTableFormComponent
    ]
})
export class DiscoveryConfigurationComponent implements OnInit, OnDestroy {
  @Output() closeDiscoveryCategoryConfig = new EventEmitter();
  @Input() discoveryCategoryConfigType: any;
  @Input() switchFromUser: boolean = false;
  isOwnerRegisterDataType: boolean = false;
  subscription = new Subscription();
  menus = [];
  selectedStepIndex: number = 0;
  searchQuery: string = '';
  expandedPanel: any = {};
  forms = [];
  categories = [];
  allUserTypeForms = [];
  vaults = [];
  userObject;
  isLoading = false;
  questionContentAnimationOptions: AnimationOptions = {
    path: 'assets/images/lottie-img/question-content-animation.json',
  };
  allUserConnections = [];
  logInUser = {};
  selectedPath;
  financialSteps: any[];
  pipeTimestamp = 0;
  filteredPaths = [];
  isManualAccountsLoading = false;
  vaultStateObject$;
  isDataExtractionType = '';

  pathSortState = new Map<string, { sortBy: 'dateAdded' | 'name'; sortDir: 'asc' | 'desc' }>();

  constructor(
    private discoveryService: DiscoveryService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private vaultService: VaultStoreService,
    private shareService: ShareService,
    private store$: Store<RootStoreState.State>,
    private commonService: CommonService,
    private toastr: ToastrService,
    private store: Store,
    private shareVaultService: SharedVaultService,
    private itemResolveService: ItemToResolveService,
    private refreshReportService: RefreshReportService,
    private homeSubjectService: HomeSubjectService,
    private dataExtractionToggle: DataExtractionToggle
  ) {
    this.vaultStateObject$ = this.vaultService.vaultObject;

    this.subscription.add(
      this.vaultStateObject$.subscribe((object) => {
        this.categories = object.categories;
      })
    );

    this.subscription.add(
      this.dataExtractionToggle.getMessage().subscribe((res) => {
        this.isDataExtractionType = res.message?.type;
        this.cd.detectChanges();
      })
    );
  }

  ngOnInit() {
    if (this.discoveryCategoryConfigType.category_type === 'contact' || this.discoveryCategoryConfigType.category_type === 'password') {
      this.isOwnerRegisterDataType = true;
    }
    this.createDiscoveryType();
    this.getDiscoveryConfiguration();
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
        this.categories = state.categories;
        this.vaults = [...state.vaults];
        this.vaults?.sort((a: any, b: any) => Number(b.cnt) - Number(a.cnt));
      })
    );
    this.subscription.add(
      this.store$.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe(async (result) => {
        if (result) {
          this.userObject = result;
        }
      })
    );
    this.getMemberData();
  }

  createDiscoveryType() {
    if (!this.discoveryCategoryConfigType.discovery_type_id && !this.discoveryCategoryConfigType.id) {
      const body = {
        vault_folder_id: this.discoveryCategoryConfigType.vault_folder_id,
      };
      this.subscription.add(
        this.discoveryService.createDiscoveryType(body).subscribe((response) => {
          if (response) {
            this.discoveryCategoryConfigType.discovery_type_id = response.id;
            this.cd.detectChanges();
          }
        })
      );
    }
  }

  getMemberData() {
    this.subscription.add(
      this.store.select(relationshipSelectors.getAndFilterNonProfessionalExcludeExistingUser('', [])).subscribe((data) => {
        const updatedObject = [];
        data.forEach((element) => {
          const tempElement = {
            ...element,
            name: '',
          };
          tempElement.id = element?.user_id;
          tempElement.name = element?.user_first_name + ' ' + element?.user_last_name;
          updatedObject.push(tempElement);
        });
        this.allUserConnections = [
          ...updatedObject.map(({ id, user_id, name, relationship_name, user_profile_image_url, user_first_name, user_last_name }) => ({
            id,
            user_id,
            name,
            relationship_name,
            user_profile_image_url,
            key: ConfigurationType.USERS,
            user_first_name,
            user_last_name,
          })),
        ];
        this.logInUser = this.allUserConnections.find((user) => user.id === this.userObject.id);
        if (this.logInUser) {
          this.allUserConnections.splice(this.allUserConnections.indexOf(this.logInUser), 1);
        }
      })
    );
  }

  getFormData(template) {
    const form = this.forms?.find((f) => f.type.trim() === template.trim());
    return form;
  }

  getDiscoveryFinancialAccounts(paths) {
    this.isLoading = true;
    paths?.forEach((path) => {
      path.template_display_name = path.path_name;
      path.path = `Other Financial Accounts`;
      path.zero_state_Text = 'No <path> to show';
      path.template = 'Financial Accounts';
      path.template2 = 'Financial Accounts';
    });
    this.menus.push({
      configuration_group: 'Manual Accounts',
      form_name: 'Manual Accounts',
      name: 'Manual Accounts',
      paths: paths ?? [],
    });
    this.isLoading = false;
    this.cd.detectChanges();
  }

  getDiscoveryConfiguration() {
    this.isLoading = true;
    this.subscription.add(
      this.discoveryService.getDiscoveryConfiguration(this.discoveryCategoryConfigType.name).subscribe((response) => {
        if (response) {
          try {
            if (
              this.discoveryCategoryConfigType?.name === 'Financial Accounts' &&
              response.length > 0 &&
              response[0]?.paths?.length > 0 &&
              response[0]?.paths[0]?.steps?.length > 0
            ) {
              this.financialSteps = [...response[0]?.paths[0]?.steps];
              for (let index = 0; index < this.financialSteps.length; index++) {
                const element = this.financialSteps[index];
                this.financialSteps[index].formId = this.forms?.find((form) => form.type === element.template)?.id;
                this.financialSteps[index].image = this.forms?.find((form) => form.type === element.template)?.image;
              }
            }
            this.menus = [...response.filter((menu) => menu.configuration_group)];

            if (this.menus?.length > 0 && response[0]?.paths?.length > 0 && this.discoveryCategoryConfigType?.name != 'Financial Accounts') {
              for (let index = 0; index < this.menus.length; index++) {
                const step = this.menus[index];
                step.paths = [...step.paths.filter((path) => path.template)];
                step.paths.forEach((path) => {
                  const form = this.getFormData(path.template);
                  if (form) {
                    path.formId = form.id;
                    path.image = form.image;
                  }
                  if (path.template2) {
                    const form2 = this.getFormData(path.template2);
                    if (form2) {
                      path.form2Id = form2.id;
                      path.image2 = form2.image;
                    }
                  }
                });
              }
            }

            this.selectedStepIndex = 0;
            this.processFilteredPaths();
            this.getConfigurationGroupQuestion();
            this.getConfigurationGroupSubText();
            if (this.discoveryCategoryConfigType?.name === 'Financial Accounts') {
              this.getDiscoveryFinancialAccounts(response[0]?.paths);
            } else if (
              this.discoveryCategoryConfigType.category_type === 'contact' ||
              this.discoveryCategoryConfigType.category_type === 'password'
            ) {
              this.getNonVaultForms();
              this.isLoading = false;
              this.cd.detectChanges();
            } else {
              this.getFormsTypeUser();
              this.isLoading = false;
              this.cd.detectChanges();
            }
          } catch (error) {
            this.isLoading = false;
            console.error('🚀 ~ DiscoveryConfigurationComponent ~ this.discoveryService.getDiscoveryConfiguration ~ error:', error);
          }
        }
      })
    );
  }

  getDiscoveryFinancialAccountsForms() {
    this.subscription.add(
      this.discoveryService.getAllUserFormByDiscoveryFinancialAccountId().subscribe((res) => {
        this.allUserTypeForms = [...res];
        this.mapFormsWithSteps();
        this.menus[this.selectedStepIndex].paths[0].forms = [...this.allUserTypeForms];
        this.processFilteredPaths();
        this.isManualAccountsLoading = false;
        this.cd.detectChanges();
      })
    );
  }

  getNonVaultForms() {
    this.subscription.add(
      this.shareVaultService.getNonVaultForms(this.discoveryCategoryConfigType.category_type, null).subscribe(
        (res) => {
          // this.nonVaultForms = res;
          this.allUserTypeForms = [...res];
          this.mapFormsWithStepsForRegister();
          // this.prepareUserArray();
          // this.getVaultRegisterMembers();
          this.cd.detectChanges();
        },
        () => {
          this.toastr.error('Failed to fetch non-vault forms');
          this.cd.detectChanges();
        }
      )
    );
  }

  mapFormsWithStepsForRegister() {
    for (let index = 0; index < this.menus[this.selectedStepIndex]?.paths.length; index++) {
      const element = this.menus[this.selectedStepIndex]?.paths[index];
      let forms = [];
      if (this.discoveryCategoryConfigType.category_type === 'contact') {
        forms = this.allUserTypeForms.filter((form) => form.template_sub_type === element.path);
      } else {
        forms = this.allUserTypeForms.filter((form) => form.fid === element.formId);
      }
      this.menus[this.selectedStepIndex].paths[index].forms = forms;
    }

    const remainingItems = this.allUserTypeForms.filter(
      (item) => !this.menus[this.selectedStepIndex].paths.some((menuItem) => menuItem.forms.includes(item))
    );
    if (remainingItems && remainingItems.length && this.discoveryCategoryConfigType.category_type === 'contact') {
      this.menus[this.selectedStepIndex].paths.unshift({
        ...this.menus[this.selectedStepIndex].paths[0],
        path: 'Contact',
        path_name: 'Contact',
        forms: [...remainingItems],
      });
    }
  }

  mapFormsWithSteps() {
    for (let index = 0; index < this.menus[this.selectedStepIndex]?.paths.length; index++) {
      const element = this.menus[this.selectedStepIndex]?.paths[index];
      let forms = this.allUserTypeForms.filter((form) => form.fid === element.formId);
      if (element.form2Id) {
        forms = [...forms, ...this.allUserTypeForms.filter((form) => form.fid === element.form2Id)];
      }
      this.menus[this.selectedStepIndex].paths[index].forms = [
        ...(this.menus[this.selectedStepIndex]?.paths[index]?.forms || []).filter((form) => !form.fid),
        ...forms,
      ];
    }
  }

  getFormsTypeUser() {
    const formIds = [];
    for (let index = 0; index < this.menus[this.selectedStepIndex]?.paths.length; index++) {
      const element = this.menus[this.selectedStepIndex]?.paths[index];
      if (element.formId) {
        formIds.push(element.formId);
      }
      if (element.form2Id) {
        formIds.push(element.form2Id);
      }
    }
    this.subscription.add(
      this.shareService.getFormsTypeUser({ formids: formIds }).subscribe(
        (res) => {
          res.forEach((element) => {
            element.name = element?.form_name;
          });
          this.allUserTypeForms = [...res];
          this.mapFormsWithSteps();
          this.cd.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }

  getConfigurationGroupQuestion() {
    if (!this.menus[this.selectedStepIndex]?.configuration_group_question) {
      return;
    }
    this.menus[this.selectedStepIndex].configuration_group_question = this.menus[this.selectedStepIndex]?.configuration_group_question
      .replace('<configuration group>', `<span class="font-bold text-[#25508E]">${this.menus[this.selectedStepIndex]?.configuration_group}</span>`)
      .replace('<Institution Name>', `<span class="font-bold text-[#25508E]">${this.menus[this.selectedStepIndex]?.configuration_group}</span>`);
    this.cd.detectChanges();
  }

  getConfigurationGroupSubText() {
    this.menus[this.selectedStepIndex].configuration_group_subtext = this.menus[this.selectedStepIndex]?.configuration_group_subtext
      .replace(
        'Each institution will only need to be listed one time.',
        `<span class="font-bold text-[#18191C]">Each institution will only need to be listed one time.</span>`
      )
      .replace('each unique login', `<span class="font-bold text-[#18191C]">each unique login</span>`)
      .replace('then clicking connect', `<span class="font-bold text-[#18191C]">then clicking connect</span>`)
      .replace('<institution name>', `<span>institution name</span>`)
      .replace(' <nickname>', `<span>nickname</span>`);
    this.cd.detectChanges();
  }

  getZeroStateText(path) {
    return path.zero_state_Text
      .replace('<Template name plural>', `<span class="font-bold text-[#25508E]">${this.discoveryService.plural(path.template_display_name)}</span>`)
      .replace('<Template name>', `<span class="font-bold text-[#25508E]">${path.template_display_name}</span>`)
      .replace('<template name>', `<span class="font-bold text-[#25508E]">${path.template_display_name}</span>`)
      .replace('<Path Name>', `<span class="font-bold text-[#25508E]">${path?.path_name}</span>`)
      .replace('<step name>', `<span class="font-bold text-[#25508E]">${path?.path_name}</span>`)
      .replace('<path>', `<span class="font-bold text-[#25508E]">${path?.path}</span>`)
      .replace(
        '<template name plural>',
        `<span class="font-bold text-[#25508E]">${this.discoveryService.plural(path?.template_display_name)}</span>`
      );
  }

  selectMenu(selectedMenu: any = {}, index: number = -1) {
    this.searchQuery = '';
    this.cd.detectChanges();
    if (selectedMenu?.configuration_group) {
      // const stepIndex = this.menus.findIndex((step) => step.configuration_group === selectMenu.configuration_group);
      this.selectedStepIndex = index;
      this.cd.detectChanges();
      this.getConfigurationGroupQuestion();
      if (this.discoveryCategoryConfigType.name === 'Financial Accounts' && this.selectedStepIndex === 1) {
        this.isManualAccountsLoading = true;
        this.cd.detectChanges();
        this.getDiscoveryFinancialAccountsForms();
      } else if (this.discoveryCategoryConfigType.category_type === 'contact' || this.discoveryCategoryConfigType.category_type === 'password') {
        this.getNonVaultForms();
      } else {
        this.getFormsTypeUser();
      }
    } else {
      this.selectedStepIndex = this.menus.length;
    }
    this.searchQuery = '';
    this.processFilteredPaths();
    this.cd.detectChanges();
  }

  addNewTemplateRow(index: number, path: any) {
    this.expandedPanel[index] = true;
    const pathIndex = this.menus[this.selectedStepIndex].paths.findIndex((p) => p.path === path.path);
    this.menus[this.selectedStepIndex].paths[pathIndex].forms ??= [];
    this.menus[this.selectedStepIndex].paths[pathIndex].forms.unshift({
      form_name: path.template,
      template: path.template,
      formId: path.formId,
      form2Id: path.form2Id,
    });
    // Create a new reference for the entire menus array to trigger pipe re-evaluation
    // this.menus = [...this.menus];
    // this.pipeTimestamp++;
    this.cd.detectChanges();
  }

  updateTemplateRow(form: any, index: number, path: any, row: any) {
    const pathIndex = this.menus[this.selectedStepIndex].paths.findIndex((p) => p.path === path.path);
    const rowIndex = this.menus[this.selectedStepIndex].paths[pathIndex].forms.findIndex((r) => r.id === row.id);
    this.menus[this.selectedStepIndex].paths[pathIndex].forms[rowIndex] = form;
    this.pipeTimestamp++;
    this.cd.detectChanges();
  }

  removeTemplateRow(index: number, path: any, row: any) {
    const pathIndex = this.menus[this.selectedStepIndex].paths.findIndex((p) => p.path === path.path);
    const rowIndex = this.menus[this.selectedStepIndex].paths[pathIndex].forms.findIndex((r) => r.id === row.id);
    const rowData = this.menus[this.selectedStepIndex].paths[pathIndex].forms[rowIndex];
    // const path = this.menus[this.selectedStepIndex].paths[pathIndex].forms[index];
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '386px',
      data: {
        title: 'Delete Template',
        materialIcon: 'delete',
        text: `Are you sure you want to delete ${rowData?.form_name}? `,
        proceedTitle: 'Delete',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (rowData.id) {
            const modelRequest = {
              type: 'form',
              ids: [rowData.id],
            };
            this.subscription.add(
              this.commonService.moveToTrashForm(modelRequest).subscribe((data) => {
                if (data) {
                  this.toastr.success(`${rowData?.form_name} moved to trash`);
                  this.menus[this.selectedStepIndex].paths[pathIndex].forms.splice(rowIndex, 1);
                  this.pipeTimestamp++;
                  this.cd.detectChanges();
                }
              })
            );
          } else {
            this.menus[this.selectedStepIndex].paths[pathIndex].forms.splice(rowIndex, 1);
            this.pipeTimestamp++;
            this.cd.detectChanges();
          }
        }
      })
    );
  }

  getPathKey(path: any): string {
    return path?.id ?? path?.path_name ?? path?.name ?? '';
  }

  getSortState(path: any): { sortBy: 'dateAdded' | 'name'; sortDir: 'asc' | 'desc' } {
    return this.pathSortState.get(this.getPathKey(path)) ?? { sortBy: 'dateAdded', sortDir: 'desc' };
  }

  closeSideNav() {
    this.pathSortState.clear();
    const unsavedTemplates = [];
    for (let index = 0; index < this.menus.length; index++) {
      const element = this.menus[index];
      element.paths?.forEach((path: any) => {
        if (path.forms?.filter((form: any) => !form.id).length > 0) {
          unsavedTemplates.push(path);
        }
      });
    }

    if (unsavedTemplates.length > 0) {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '386px',
        data: {
          title: 'Close without Saving?',
          materialIcon: 'info_outline',
          discoveryText: `<span class="font-open-sans text-sm font-medium leading-6 text-[#18191C]">Are you sure you want to exit as there are incomplete items that have not been saved.</span>`,
          proceedTitle: 'Yes',
          backBUttonTitle: 'No',
        },
      });

      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
            this.closeDiscoveryCategoryConfig.emit();
            this.itemResolveService.sendMessage({
              refreshItemToResolve: true,
            });
          }
        })
      );
    } else {
      this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
      this.closeDiscoveryCategoryConfig.emit();
      this.itemResolveService.sendMessage({
        refreshItemToResolve: true,
      });
      if (
        this.discoveryCategoryConfigType.name === 'Legal Entity' ||
        this.discoveryCategoryConfigType.name === 'Financial Accounts' ||
        this.discoveryCategoryConfigType.name === 'Assets'
      ) {
        this.refreshReportService.sendMessage({
          refreshItemToResolve: true,
        });
      }
    }
  }

  onClearInput() {
    this.searchQuery = '';
  }

  changeStep(step) {
    if (this.discoveryCategoryConfigType.name === 'Entities') {
      this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
    }
    this.selectedStepIndex = this.selectedStepIndex + step;
    this.processFilteredPaths();
    this.searchQuery = '';
    this.cd.detectChanges();
    this.getConfigurationGroupQuestion();
    if (this.discoveryCategoryConfigType.name === 'Financial Accounts') {
      this.isManualAccountsLoading = true;
      this.cd.detectChanges();
      this.getDiscoveryFinancialAccountsForms();
    } else if (this.discoveryCategoryConfigType.category_type === 'contact' || this.discoveryCategoryConfigType.category_type === 'password') {
      this.getNonVaultForms();
    } else {
      this.getFormsTypeUser();
    }
    this.cd.detectChanges();
  }

  completeDiscoveryType() {
    this.subscription.add(
      this.discoveryService
        .updateDiscoveryType({
          vault_folder_id: this.discoveryCategoryConfigType.vault_folder_id ?? this.discoveryCategoryConfigType.id,
          status: 'complete',
        })
        .subscribe(() => {
          this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userObject?.id, false));
          this.closeDiscoveryCategoryConfig.emit(true);
          this.itemResolveService.sendMessage({
            refreshItemToResolve: true,
          });
          this.refreshReportService.sendMessage({
            refreshItemToResolve: true,
          });
        })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  processFilteredPaths() {
    const allPaths = [...this.menus?.[this.selectedStepIndex]?.paths];
    this.filteredPaths = allPaths.filter((item) => {
      const filteredTemplates = item.forms?.filter((member) => member.form_name.toLowerCase().includes(this.searchQuery.toLowerCase()));

      if (item.path_name.toLowerCase().includes(this.searchQuery.toLowerCase()) || filteredTemplates.length) {
        return { ...item, forms: filteredTemplates }; // Return filtered members only
      }

      return null;
    });
  }

  filterForms(path: any): any[] {
    if (!path.forms) {
      return [];
    }

    let result = path.forms.filter((member) => member.form_name.toLowerCase().includes(this.searchQuery.toLowerCase()));

    const sortState = this.getSortState(path);
    result = [...result].sort((a, b) => {
      // Records without id always come first
      const aHasId = !!a.id;
      const bHasId = !!b.id;
      if (!aHasId && bHasId) return -1;
      if (aHasId && !bHasId) return 1;
      if (!aHasId && !bHasId) return 0;

      if (sortState.sortBy === 'name') {
        const cmp = (a.form_name ?? '').toLowerCase().localeCompare((b.form_name ?? '').toLowerCase());
        return sortState.sortDir === 'asc' ? cmp : -cmp;
      }
      const dateA = a.created_at ?? a.createdAt;
      const dateB = b.created_at ?? b.createdAt;
      const tsA = dateA ? new Date(dateA).getTime() : 0;
      const tsB = dateB ? new Date(dateB).getTime() : 0;
      return sortState.sortDir === 'desc' ? tsB - tsA : tsA - tsB;
    });
    return result;
  }

  toggleSortBy(field: 'dateAdded' | 'name', path: any) {
    const key = this.getPathKey(path);
    const current = this.getSortState(path);
    if (current.sortBy === field) {
      this.pathSortState.set(key, { ...current, sortDir: current.sortDir === 'asc' ? 'desc' : 'asc' });
    } else {
      this.pathSortState.set(key, { sortBy: field, sortDir: field === 'name' ? 'asc' : 'desc' });
    }
    this.cd.markForCheck();
  }

  extractionStart() {
    this.subscription.add(
      this.dataExtractionToggle.sendMessage({
        type: this.discoveryCategoryConfigType?.name,
        open: true,
      })
    );
  }

  getTooltipText(type: string, path: any = {}) {
    switch (type) {
      case 'type':
        return 'You can track individual items, groups of items, or both.';
      case 'owners':
        return `Owners will have the ability to edit and manage this ${this.discoveryCategoryConfigType.category_type}. By contrast, sharing lets someone else view this ${this.discoveryCategoryConfigType.category_type}, which can be assigned in a future step.`;
      case 'vault':
        return 'The vault selected will be the end destination where this template is stored.';
      default:
        return `Members will have the ability to edit and manage the vault where this entity lives, as well as other items within that vault. By contrast, sharing lets someone else view this ${path.template}, which can be assigned in a future step.`;
    }
  }

  handleMainSideNav(val: any) {
    this.cd.detectChanges();
  }
}
